import {
  ChartColumnBig,
  FileDown,
  Mail,
  MapPin,
  MapPinPen,
  Search,
} from "lucide-react";

const iconMap: Record<string, React.FC<{ className?: string }>> = {
  search: Search,
  mail: Mail,
  fileDown: FileDown,
  mapPin: MapPin,
  mapPinPen: MapPinPen,
  chartColumnBig: ChartColumnBig,
};

export function IconRenderer({
  icon,
  className,
}: {
  icon: string;
  className?: string;
}) {
  const Icon = iconMap[icon];
  if (!Icon) return null;
  return <Icon className={className} />;
}
